import React, { useEffect } from "react";

// components
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Button
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import MaterialTable from 'material-table';
import Header from "../../../components/Headers/Header.jsx";

// services
import { showMessage } from "../../../services/message.js";
import { api_GET } from "../../../services/api_service.js";
import { getSessionCookie } from "../../../services/session.js";

// views
import UsuariosForm from '../../../views/admin/seguranca/UsuariosForm.jsx';

//Constants
import { table_translate, table_style } from "../../../constants/MaterialTable.js";

export default function UsuariosList({ history }) {
  const session = getSessionCookie();

  const [list_table, set_list_table] = React.useState([])
  const [list_loading, set_list_loading] = React.useState(false);

  const [showDetail, setshowDetail] = React.useState(false);
  const [itemDetail, setitemDetail] = React.useState(null);

  const GetList = () => {
    set_list_loading(true);

    let endpoint = 'usuario';
    if (session.concessionariaId != null)
      endpoint += `/GetByConcessionaria/${session.concessionariaId}`;

    api_GET(endpoint).then(result => {
      set_list_loading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        set_list_table(result.data);
      }
    });
  }

  const Edit = (event, rowData) => {
    api_GET(`usuario/${rowData.usuarioId}`).then(result => {
      set_list_loading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        setshowDetail(true);
        setitemDetail(result.data);
      }
    });
  }

  const Add = () => {
    setitemDetail(null);
    setshowDetail(true);
  };

  const handleReturn = (item) => {
    setshowDetail(false);
    GetList();
  }

  useEffect(() => {
    GetList();
  }, []);

  const columnsProp = [
    { title: 'Nome', field: 'nome' },
    { title: 'Perfil', field: 'perfil' },
    { title: 'Login', field: 'login' },
    { title: 'Email', field: 'email' },
    { title: 'Recurso', field: "veiculo.placa", render: (rowData) => rowData.veiculo ? rowData.veiculo.placa : "Nenhum" },
    { title: 'Status', field: 'ativo', render: (rowData) => rowData.ativo == true ? "Ativo" : "Inativo" },
  ]

  return (
    <>
      <Header />
      <Container className="mt--9" fluid>

        {!showDetail &&
          <Row>
            <Container className="mt-1" fluid>
              <Card className="shadow">
                <CardHeader className="border-0">
                  <Row>
                    <Col md="6">
                      <strong> Usuários</strong>
                    </Col>
                    <Col md="6" className="text-right">
                      <Button color="primary" type="submit" onClick={() => Add()}>
                        <FontAwesomeIcon icon={faPlus} />  Novo Usuário
                      </Button>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col md="12">
                      <MaterialTable
                        title="Lista de Concessionárias"
                        columns={columnsProp}
                        data={list_table}
                        isLoading={list_loading}
                        options={{ ...table_style, pageSize: 20, pageSizeOptions: [20, 50, list_table.length] }}
                        actions={[
                          {
                            icon: 'edit',
                            tooltip: 'Editar Registro',
                            onClick: (event, rowData) => Edit(event, rowData)
                          }
                        ]}
                        localization={table_translate}
                      />
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Container>
          </Row>
        }

        {showDetail &&
          <UsuariosForm handleReturn={handleReturn} item={itemDetail}></UsuariosForm>
        }

      </Container>

    </>
  );
}
